export default function Loading() {
    return (
        <div className="flex items-center justify-center w-full h-full">
            <span className="w-32 h-32 border-t-2 border-b-2 border-gray-900 rounded-full animate-spin"></span>
        </div>
    )
}
